import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { RefreshCw } from "lucide-react";
import { STATE_STYLE } from "../pages/Renew";

export default function MembershipCard({ kind }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/renewals/mine").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  const shown = (items || []).filter((p) => !kind || p.kind === kind);
  if (!shown.length) return null;
  return (
    <div data-testid="membership-card" className="bg-[#FFFDF9] sacred-border rounded-2xl p-6">
      <div className="flex items-center gap-2"><RefreshCw className="w-5 h-5 text-[#E65100]" /><div className="overline">Your plans & renewals</div></div>
      <div className="mt-4 space-y-3">
        {shown.map((p) => {
          const [label, cls] = STATE_STYLE[p.state];
          return (
            <div key={p.token} data-testid={`membership-${p.kind}`} className="flex flex-wrap items-center gap-3 bg-white border border-[#D4AF37]/30 rounded-xl px-4 py-3">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-[#4A0E17] truncate">{p.plan_name}</div>
                <div className="text-xs text-[#63534E]">{p.state === "active" || p.state === "grace" ? "Ends" : "Ended"} {p.expiry} · {p.auto_renew ? "renewal reminders on" : "renewal cancelled"}</div>
              </div>
              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${cls}`}>{label}</span>
              {p.autopay_status === "active" && <span data-testid={`autopay-badge-${p.kind}`} className="px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800">Auto-pay</span>}
              {p.last_ecard_id && <Link to={`/ecard/${p.last_ecard_id}`} data-testid={`ecard-link-${p.kind}`} className="text-sm text-[#8C6D3B] font-semibold">Your e-card</Link>}
              <Link to={`/renew/${p.token}`} data-testid={`manage-${p.kind}`} className="text-sm text-[#E65100] font-semibold">Renew or manage →</Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
